import React from 'react';
import PropTypes from 'prop-types';
import { Chip as MuiChip } from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import styleConstants from '@digital-hig/theme-data/lib/build/json/light/design-tokens.json';

// Define status map as a constant outside the component
const STATUS_MAP = {
  new: {
    label: 'New',
    color: styleConstants.primitives.colors.accent.iris,
    fontColor: styleConstants.primitives.colors.primary.white,
  },
  queued: {
    label: 'Queued',
    color: styleConstants.primitives.colors.accent.gold,
    fontColor: styleConstants.primitives.colors.primary.black,
  },
  scheduled: {
    label: 'Scheduled',
    color: styleConstants.primitives.colors.accent.gold,
    fontColor: styleConstants.primitives.colors.primary.black,
  },
  completed: {
    label: 'Completed',
    color: styleConstants.primitives.colors.detail['slate-light'],
    fontColor: styleConstants.primitives.colors.primary.black,
  },
  cancelled: {
    label: 'Cancelled',
    color: styleConstants.primitives.colors.detail['slate-light'],
    fontColor: styleConstants.primitives.colors.primary.black,
  },
};

// Set of status IDs that should be treated as "queued"
const QUEUED_ALIASES = new Set(['queued', 'requested', 'in_progress', 'active', 'viewed']);

const determineStatusKey = (rawId) => {
  const safeId = (rawId || '').toLowerCase();
  if (QUEUED_ALIASES.has(safeId)) return 'queued';
  if (STATUS_MAP[safeId]) return safeId;
  return 'cancelled';
};

const Chip = ({
  value: {
    id = '', label = '', color = '', fontColor = '',
  } = {},
}) => {
  const key = determineStatusKey(id);
  const base = STATUS_MAP[key];

  const statusData = {
    color: color || base.color,
    fontColor: fontColor || base.fontColor,
    label: label || base.label,
  };

  return (
    <MuiChip
      data-testid={`chip-data-${id}`}
      label={statusData.label}
      sx={{ backgroundColor: statusData.color, color: statusData.fontColor }}
    />
  );
};

Chip.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    color: PropTypes.string,
    fontColor: PropTypes.string,
  }).isRequired,
};

export default Chip;
